import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import { Card } from "@/components/ui/card";
import retractableTrayImg from "@/assets/accessories/retractable-tray-baffle.png";
import protectionCase1Img from "@/assets/accessories/protection-case-1.png";
import protectionCase2Img from "@/assets/accessories/protection-case-2.png";
import displayStandImg from "@/assets/accessories/display-stand.png";
import fixedCupHolderImg from "@/assets/accessories/fixed-cup-holder.png";
import carpetVacuumingImg from "@/assets/accessories/carpet-vacuuming.png";
import chargingStationCC1Img from "@/assets/accessories/charging-station-cc1.png";
import selfCleaningDockingImg from "@/assets/accessories/self-cleaning-docking.png";
import mobileWaterStationImg from "@/assets/accessories/mobile-water-station.png";
import conveyorSingleImg from "@/assets/accessories/conveyor-single.png";
import towingDeviceImg from "@/assets/accessories/towing-device.png";
import liftingRackImg from "@/assets/accessories/lifting-rack.png";
import elevatorControlImg from "@/assets/accessories/elevator-control.png";
import watch4gImg from "@/assets/accessories/4g-watch.png";
import puduPagerImg from "@/assets/accessories/pudu-pager.png";
import telephoneSystemImg from "@/assets/accessories/telephone-system.png";
import turnstilesControlImg from "@/assets/accessories/turnstiles-control.png";
import flashbotVendingImg from "@/assets/accessories/flashbot-vending.png";
import reflectivePostImg from "@/assets/accessories/reflective-post.png";
import chargingStationImg from "@/assets/accessories/charging-station.png";
import traySetsImg from "@/assets/accessories/tray-sets.png";

const accessories = [
  // Delivery Robot Accessories
  {
    name: "Retractable Tray Baffle",
    description: "Secure tray baffle system for safe food and item delivery",
    price: "Contact for pricing",
    category: "Delivery Accessories",
    compatibleWith: "BellaBot, KettyBot Pro, PuduBot 2",
    image: retractableTrayImg
  },
  {
    name: "Protection Case",
    description: "Premium protection cases for various robot models - multiple sizes available",
    price: "Starting at $149",
    category: "Protection & Safety",
    compatibleWith: "All PUDU Robots",
    image: protectionCase1Img
  },
  {
    name: "Display Stand",
    description: "Professional display stands for robot showcasing and storage",
    price: "Starting at $89",
    category: "Service Accessories",
    compatibleWith: "All Delivery Robots",
    image: displayStandImg
  },
  {
    name: "Fixed Cup Holder",
    description: "Secure cup holders for beverage delivery - multiple configurations",
    price: "Starting at $49",
    category: "Delivery Accessories",
    compatibleWith: "BellaBot, KettyBot Pro, PuduBot 2",
    image: fixedCupHolderImg
  },
  {
    name: "Tray Sets",
    description: "Additional serving trays for expanded delivery capacity",
    price: "Starting at $79",
    category: "Delivery Accessories",
    compatibleWith: "BellaBot, KettyBot Pro",
    image: traySetsImg
  },
  
  // Cleaning Robot Accessories
  {
    name: "Charging Station (CC1)",
    description: "Automatic charging dock with water addition for CC1 cleaning robots",
    price: "Starting at $499",
    category: "Power & Charging",
    compatibleWith: "PUDU CC1, CC1 Pro",
    image: chargingStationCC1Img
  },
  {
    name: "PUDU Self-Cleaning Docking Station",
    description: "Advanced self-cleaning and auto water refill station for CC1 series",
    price: "Starting at $799",
    category: "Cleaning Accessories",
    compatibleWith: "PUDU CC1, CC1 Pro",
    image: selfCleaningDockingImg
  },
  {
    name: "PUDU Mobile Water Station",
    description: "Portable water reservoir for extended cleaning operations",
    price: "Starting at $299",
    category: "Cleaning Accessories",
    compatibleWith: "CC1, CC1 Pro, MT1 Series",
    image: mobileWaterStationImg
  },
  {
    name: "Carpet Vacuuming Assembly",
    description: "Specialized attachment for deep carpet cleaning",
    price: "Starting at $349",
    category: "Cleaning Accessories",
    compatibleWith: "PUDU CC1, CC1 Pro",
    image: carpetVacuumingImg
  },

  // Industrial Delivery Accessories
  {
    name: "Conveyor - Single Layer",
    description: "Single-layer conveyor system for automated loading/unloading",
    price: "Contact for pricing",
    category: "Industrial Accessories",
    compatibleWith: "PUDU T300, T600",
    image: conveyorSingleImg
  },
  {
    name: "Towing Device",
    description: "Heavy-duty towing attachment for material transport",
    price: "Starting at $399",
    category: "Industrial Accessories",
    compatibleWith: "PUDU T300, T600",
    image: towingDeviceImg
  },
  {
    name: "Lifting Rack",
    description: "Automated lifting rack for vertical material handling",
    price: "Contact for pricing",
    category: "Industrial Accessories",
    compatibleWith: "PUDU T600",
    image: liftingRackImg
  },

  // IoT & Control Accessories
  {
    name: "Elevator Control Module",
    description: "IoT module for seamless elevator integration and control",
    price: "Starting at $449",
    category: "IoT Accessories",
    compatibleWith: "All PUDU Robots",
    image: elevatorControlImg
  },
  {
    name: "4G Watch",
    description: "Remote control and monitoring watch for robot management",
    price: "Starting at $199",
    category: "IoT Accessories",
    compatibleWith: "All PUDU Robots",
    image: watch4gImg
  },
  {
    name: "PUDU Pager",
    description: "Customer paging system for service notification",
    price: "Starting at $149",
    category: "IoT Accessories",
    compatibleWith: "Delivery Robots",
    image: puduPagerImg
  },
  {
    name: "Telephone System",
    description: "Integrated phone system for remote communication",
    price: "Contact for pricing",
    category: "IoT Accessories",
    compatibleWith: "All PUDU Robots",
    image: telephoneSystemImg
  },
  {
    name: "Turnstiles/Automatic Doors Control",
    description: "Control components for automated door and turnstile access",
    price: "Starting at $349",
    category: "IoT Accessories",
    compatibleWith: "All PUDU Robots",
    image: turnstilesControlImg
  },

  // Specialized Accessories
  {
    name: "FlashBot Vending Machine",
    description: "Automated vending machine module for FlashBot robots",
    price: "Contact for pricing",
    category: "Service Accessories",
    compatibleWith: "FlashBot Max",
    image: flashbotVendingImg
  },
  {
    name: "Reflective Post",
    description: "Safety reflective posts for enhanced visibility",
    price: "Starting at $39",
    category: "Protection & Safety",
    compatibleWith: "Industrial Robots",
    image: reflectivePostImg
  },
  {
    name: "Charging Station (General)",
    description: "Universal charging stations for delivery and service robots",
    price: "Starting at $399",
    category: "Power & Charging",
    compatibleWith: "BellaBot, KettyBot, PuduBot",
    image: chargingStationImg
  }
];

const Accessories = () => {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="border-b border-[hsl(var(--line))] glass-effect sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="font-orbitron font-bold text-xl">
            Neil <span className="text-primary">AI</span>
          </Link>
          <nav className="hidden md:flex gap-6">
            <Link to="/" className="hover:text-primary transition-colors">Home</Link>
            <Link to="/about" className="hover:text-primary transition-colors">About</Link>
            <Link to="/accessories" className="text-primary">Shop Accessories</Link>
            <Link to="/case-studies" className="hover:text-primary transition-colors">Case Studies</Link>
          </nav>
          <Button asChild size="sm" variant="secondary" className="font-bold glow-gold">
            <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
              Book a Demo
            </a>
          </Button>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12">
        {/* Hero Section */}
        <section className="text-center mb-16">
          <h1 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
            Robot <span className="text-primary">Accessories</span> & Parts
          </h1>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto mb-6">
            Enhance your PUDU robots with premium accessories, attachments, and replacement parts. 
            Everything you need to keep your automation running at peak performance.
          </p>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold">
            <a href="tel:+13369624539">
              Call to Order: (336) 962-4539
            </a>
          </Button>
        </section>

        {/* Accessories Grid */}
        <section className="mb-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {accessories.map((accessory, index) => (
              <Card key={index} className="border-[hsl(var(--line))] glass-effect p-6 hover:bg-white/10 transition-all duration-300">
                {accessory.image && (
                  <div className="mb-4 rounded-lg overflow-hidden bg-white/5 flex items-center justify-center" style={{ height: "200px" }}>
                    <img 
                      src={accessory.image} 
                      alt={accessory.name} 
                      className="w-full h-full object-contain p-4"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="mb-4">
                  <span className="text-xs text-primary font-bold uppercase tracking-wider">
                    {accessory.category}
                  </span>
                </div>
                <h3 className="font-orbitron font-bold text-xl mb-3">{accessory.name}</h3>
                <p className="text-sm text-muted-foreground mb-4">{accessory.description}</p>
                {accessory.compatibleWith && (
                  <p className="text-xs text-muted-foreground mb-3">
                    <span className="font-semibold">Compatible:</span> {accessory.compatibleWith}
                  </p>
                )}
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-lg font-bold text-primary">{accessory.price}</span>
                  <Button asChild size="sm" variant="outline" className="border-[hsl(var(--line))] hover:bg-white/10">
                    <a href="tel:+13369624539">Inquire</a>
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        </section>

        {/* Custom Solutions CTA */}
        <section className="text-center">
          <div className="border border-[hsl(var(--line))] rounded-xl p-8 md:p-12 glass-effect">
            <h2 className="font-orbitron font-bold text-3xl mb-4">
              Need <span className="text-primary">Custom Parts</span>?
            </h2>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              Can't find what you're looking for? We can source custom attachments and accessories 
              tailored to your specific needs. Contact our team for specialized solutions.
            </p>
            <div className="flex gap-4 justify-center flex-wrap">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold">
                <a href="tel:+13369624539">Call Us</a>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-[hsl(var(--line))] hover:bg-white/10 font-bold">
                <a href="mailto:neilai@neilaiglobalsolutionsllc.com">Email Us</a>
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Accessories;
